import { defineStore } from 'pinia';
import { ERaceStatus } from '~/types/races';
import { createPopulateString, parseCollectionData } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';
import type { IActionData, IActionDataExtended, IActionsStrapiResponse } from '~/types/actions';

export const useStoreActions = defineStore('actions', {
  state: () => ({
    actions: [] as IActionData[],
    requestPromise: null as Promise<IActionsStrapiResponse> | null,
  }),

  getters: {
    actionsWithStatuses(): IActionDataExtended[] {
      const dateNow = Date.now();

      return this.actions.map((action) => {
        let status: ERaceStatus;

        if (action.endDate && new Date(action.endDate).getTime() <= dateNow) {
          status = ERaceStatus.finished;
        } else if (action.startDate && new Date(action.startDate).getTime() >= dateNow) {
          status = ERaceStatus.scheduled;
        } else {
          status = ERaceStatus.active;
        }

        return { ...action, status };
      });
    },
    activeAction(): IActionDataExtended | null {
      return (
        this.actionsWithStatuses.find((action) => action.status === ERaceStatus.active) || null
      );
    },
  },

  actions: {
    async loadActionsData() {
      if (!this.requestPromise) {
        const populateString = createPopulateString(['IStrapiImage', 'progressBar']);

        this.requestPromise = strapi()
          .get('actions', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        const parsedData = parseCollectionData(response.data);
        const filteredState = this.actions.filter(
          (item) => !parsedData.find(({ id }) => id && id === item.id)
        );

        this.actions = [...filteredState, ...parsedData].sort(
          (a, b) => Number(a.position) - Number(b.position)
        );

        return true;
      } else {
        return false;
      }
    },
  },
});
